import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const AdminPanel = () => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [generatedPassword, setGeneratedPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleAddUser = async (e) => {
    e.preventDefault();

    if (password !== 'Positive_oo1') {
      setMessage(t('adminPanel.invalidPassword'));
      return;
    }

    try {
      const response = await axios.post(`https://learningplatformbc-production.up.railway.app/api/admin/add-user`, { phone });
      setGeneratedPassword(response.data.generatedPassword);
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response?.data?.message || t('adminPanel.errorAddingUser'));
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h3 className="card-title mb-3">{t('adminPanel.title')}</h3>
            {message && <div className="alert alert-info">{message}</div>}
            <form onSubmit={handleAddUser}>
              <div className="form-group mb-3">
                <label htmlFor="phone">{t('adminPanel.phoneLabel')}</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder={t('adminPanel.phonePlaceholder')}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="password">{t('adminPanel.passwordLabel')}</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder={t('adminPanel.passwordPlaceholder')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block">{t('adminPanel.addUserButton')}</button>
            </form>
            {generatedPassword && (
              <div className="mt-3">
                <h5>{t('adminPanel.generatedPasswordTitle')}</h5>
                <p>{generatedPassword}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
